export const getActiveSlideContent = (): string | null => {
  const active = document.querySelector<HTMLElement>(
    "#content-sgKecQsAYKy7MX4 .--active[data-layer-type]",
  );

  if (!active) return null;

  const type = active.getAttribute("data-layer-type");
  if (type === "slide") return active.textContent ?? null;

  const slide = active.closest<HTMLElement>('[data-layer-type="slide"]');
  return slide ? (slide.textContent ?? null) : null;
};
